<template lang="pug">
div(ref="containerRef")
    v-row.flex.rowFilterBrandCompetence.fixed-position.pt-4(ref="filterContainerRef" :style="`min-width: ${maxWidth - 20}px`")
        v-col.col-filters
            div.filters.d-flex
                div.gr-filter-input-wrapper
                    span.label #[translate Marcas]
                    div.menu
                        filter-tree-menu(style="background-color:#ffffff;" :options="competenceBrands" label-class="text-capitalize-first-letter" :itemsChecked="brandsCompetenceActive" @checked="onCheckPaintCompetence" id-key="value" label-key="name")
    v-row.px-2.ma-0(:style="`padding-top: ${filterContainerHeight}px`")
        div.margin-bottom-0.pa-3.col-12
            v-card.gridFull.ma-0
                .card-content
                    .row.d-flex.justify-center.py-4
                        div(v-if="!dataAverage.rating_global")
                            span ...
                        .d-flex.align-baseline(v-else style="font-size: 0.875rem;")
                            .block-info(v-if="dataAverage.rating_global")
                                translate Valoración media de la Marca:
                                v-chip.chipInfo.mx-2(style="font-size: 14px; color: white;" :color="getColorByNoteNormalized({note:getNoteNormalized(dataAverage.rating_global), type:'color'})" label) {{getNoteNormalized(dataAverage.rating_global) | formatNumber(1,1)}}
                            .block-info.ml-3(v-if="dataAverage.avg_reviews")
                                translate Valoración media de Mercado:
                                span.font-weight-med.mx-2(v-if="dataFilteredByBrand && dataFilteredByBrand[0]") {{ getNoteNormalized(dataFilteredByBrand[0].sector.review_rating_global) | formatNumber(1,1)}}

        info-competence(:data="filteredCompetenceWithChildren" :render-media-info="true")

        competence-last-year(ref="competenceLastYearRef")

        valoration-last-year(ref="valorationLastYearRef")

        //GRID SENTIMIENTO POR CATEGORIAS
        box-feeling-category(v-if="$config.featureConfig.feelingCategory" :data="dataFilteredByBrand")

</template>

<script>
import SkeletonCard from '@/components/common/skeletonCard.vue'
import SrvNetwork from '@/services/network.js'
import commonMixins from "@/mixins/common.js"
import brandMixin from "@/mixins/brand.js"
import BoxFeelingCategory from '@/components/global/FeelingCategory.vue'
import FilterTreeMenu from "@/components/filters/filterTreeMenu"
import InfoCompetence from "@/components/competence/InfoCompetence.vue"
import ValorationLastYear from '@/components/common/ValorationLastYear.vue'
import CompetenceLastYear from '@/components/common/CompetenceLastYear.vue'

export default {
    mixins: [commonMixins, brandMixin],
    components: { ValorationLastYear, CompetenceLastYear, InfoCompetence, FilterTreeMenu, BoxFeelingCategory, SkeletonCard },
    data() {
        return {
            dataAverage: [],
            data: [],
            competenceWithChildren: [],
            filteredCompetenceWithChildren: [],
            helpAverageGroupByValoration: this.$gettext('Data of the brand compared to its competitors: Average of the marks of all restaurants / number of restaurants'),
            helpAverageGroupByValorationAdverbia: 'Datos de la marca en comparación con sus competidores: Media de las marcas de todos los negocios / número de negocios.',
            competenceBrands: [],
            competenceBrandsSelected: [],
            valorationBrandsSelected: [],
            filterContainerHeight: 0,
            maxWidth: 0
        }
    },
    created() {
        this.$store.commit('LOADING', true)
        if (this.$store.getters.getNode > 0) {
            this.getRankingAverage()
            this.getCompetenceWithChildrens()
        }
    },
    mounted() {
        this.filterContainerHeight = this.$refs.filterContainerRef.clientHeight
        this.maxWidth = this.$refs.containerRef.clientWidth

        this.observer = new ResizeObserver((entry) => {
            if (entry.length) {
                const [el] = entry
                this.maxWidth = el.contentRect.width
            }
        })

        this.observer?.observe(this.$refs.containerRef)
    },
    methods: {
        getRankingAverage() {
            SrvNetwork.getRankingsAverage()
                .then(res => {
                    if (res.status === 200) {
                        this.dataAverage = res.data

                    } else {
                        // this.message = 'Se ha producido un error. Intentelo más tarde.'
                    }
                }, () => {
                    // this.message = 'Se ha producido un error. Intentelo más tarde.'
                })
        },
        onCheckPaintCompetence(v) {
            this.$refs.competenceLastYearRef.setFilteredBrands(v)
            this.$refs.valorationLastYearRef.setFilteredBrands(v)
            this.competenceBrandsSelected = [...v]

            const filteredBrands = v.map(item => item.name)
            const filteredItems = []

            if (filteredBrands.length === 0) return this.filteredCompetenceWithChildren = [...this.competenceWithChildren]

            this.competenceWithChildren.forEach(competence => {
                const brands = competence.items.filter((subItem, index) => index === 0 || filteredBrands.includes(subItem.name))
                if (brands.length > 1) {
                    filteredItems.push({ ...competence, items: brands })
                }
            });

            this.filteredCompetenceWithChildren = [...filteredItems];
        },
        progressbarWidth: function (points) {
            if (this.isAdverbia) {
                return 'width:' + (points * 20) + '%';
            } else {
                return 'width:' + (points * 10) + '%';
            }
        },
        getProgressBarClass: function (points) {
            if (points < 5) {
                return 'minimun';
            } else if (points <= 7.5) {
                return 'medium';
            } else {
                return 'large';
            }
        },
        getCompetenceWithChildrens: async function () {
            this.competenceWithChildren = []
            this.$store.commit('LOADING', true)
            const res = await SrvNetwork.getCompetenceGlobalWithChildren()
            if (res.status === 200) {
                this.data = res.data.current_node || []
                this.competenceBrands = []
                this.competenceBrandsSelected = []
                this.valorationBrandsSelected = []
                this.data.forEach((b, index) => {
                    if (index > 0) {
                        this.competenceBrands.push({ value: b.name, name: b.name })
                    }
                })

                //brand_information
                if (res.data.brand_information && res.data.brand_information.length > 0) {
                    this.competenceWithChildren.push({ showCompetence: false, items: res.data.brand_information })
                }

                //current_node
                if (this.data.length > 0) {
                    this.competenceWithChildren.push({ showCompetence: true, items: this.data })
                }

                //children_data
                if (res.data.children_data && res.data.children_data.length > 0) {
                    res.data.children_data.forEach((e) => {
                        this.competenceWithChildren.push({ showCompetence: false, items: e })
                    })

                }
            }
            this.$store.commit('LOADING', false)
        },
    },
    watch: {
        competenceWithChildren() {
            this.filteredCompetenceWithChildren = [...this.competenceWithChildren]
        },
        filterApply: function () {
            this.getRankingAverage()
            this.getCompetenceWithChildrens()
        },
        distanceMap(newVal) {
            if (newVal) {
                this.getRankingAverage()
                this.getCompetenceWithChildrens()
            }
        },
        getDistanceActive() {
            this.getRankingAverage()
            this.getCompetenceWithChildrens()
        }
    },
    computed: {
        distanceMap() {
            return this.$store.getters.getDistanceMap
        },
        getDistanceActive() {
            return this.$store.getters.getDistanceMapActive
        },
        brandsCompetenceActive() {
            return this.competenceBrandsSelected.map(c => c.value || c.code)
        },
        brandsValorationActive() {
            return this.valorationBrandsSelected.map(c => c.value || c.code)
        },
        dataFilteredByBrand() {
            let brands = this.data
            if (this.competenceBrandsSelected.length > 0) {
                brands = this.data.filter((b) => {
                    if (this.brandsCompetenceActive.includes(b.name)) {
                        return b
                    }
                })
                brands = [this.data[0], ...brands]
            }
            return brands
        },
        getAvgSector() {
            if (this.data[0] && this.data[0].sector) {
                return { 'sector_avg_review_count': this.data[0].sector.avg_review_count, 'sector_avg_rating_global': this.data[0].sector.review_rating_global }
            } else {
                return { 'sector_avg_review_count': 0, 'sector_avg_rating_global': 0 }
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.fixed-position {
    position: fixed;
    z-index: 2;
    right: 20px;
    background: #F2F2F2;
}

.chip {
    width: 20px;
    height: 8px;
    border-radius: 15px;

    &.chip-blue {
        background-color: #00A6D9;
    }

    &.chip-black {
        background-color: #222226;
    }

    &.chip-red {
        background-color: #F93549;
    }
}

.color-blue {
    font-size: 0.75rem;
    color: #00A6D9;
}

.color-black {
    font-size: 0.75rem;
    color: rgba(22, 22, 22, 0.8);
}

.color-red {
    font-size: 0.75rem;
    color: #F93549;
}

.tableGlobal {

    .headerTableRanking {
        .headerItem {
            text-align: right;
            font-size: 0.75rem;
            height: 41px;
            display: flex;
            align-items: center;
            justify-content: right;
            color: rgba(22, 22, 22, 0.8);

            img {
                cursor: pointer;
            }
        }
    }

    .contentTableRanking {
        .itemContent {
            text-align: center;
            font-size: 0.875rem;
            border-top: 1px solid #9797973d;
            height: 41px;
            display: flex;
            align-items: center;
        }
    }
}

.v-application #tableRanking .elevation-1 {
    box-shadow: none !important;
}

#tableValoracionMedia {
    .col-name {
        max-width: 20.33%;
        flex: 0 0 20.33%;
        margin-right: 2.5%;
        padding-left: 10px;
        text-align: left;
        justify-content: initial;

        &.textBlackGroup {
            color: #000;
        }

        &.media-cadena {
            color: #979797;

            span {
                letter-spacing: -0.02px;
            }
        }
    }

    .col-note {
        max-width: 35.47%;
        flex: 0 0 35.47%;
        margin-right: 2.5%;
        text-align: left;
        justify-content: initial;
    }

    .col-opinions {
        max-width: 10.47%;
        flex: 0 0 10.47%;
        margin-right: 2.5%;
    }
}

.gridFull {
    .bodyIndicators {
        .progressbar {
            margin-bottom: 0;
        }
    }
}

.colBrand {
    width: 14%;
    flex: 14%;
    max-width: 14%;

    .colChartBrand {
        width: 10%;
        min-width: 90px;
        display: inline-block;
        margin-right: 1%;
    }
}

.rowMainSector {
    display: flex;
    width: 100%;
}

.rowFilterBrandCompetence {
    padding-left: 20px;

    .gr-filter-input-wrapper {
        margin-bottom: 0;
    }
}
</style>
